import gbCustom from "../../../assets/Product_img/gb_custom/1.jpg";
import gbCustom1 from "../../../assets/Product_img/gb_custom/2.jpg";
import gbCustom2 from "../../../assets/Product_img/gb_custom/3.jpg";
import gbCustom3 from "../../../assets/Product_img/gb_custom/4.jpg";
import first from "../../../assets/Product_img/common/1.jpeg";
import second from "../../../assets/Product_img/common/2.jpeg";
import third from "../../../assets/Product_img/common/3.jpeg";
import four from "../../../assets/Product_img/common/4.jpeg";
import five from "../../../assets/Product_img/common/5.jpeg";

export const proLabGBCustom = {
  hero: {
    title: "Pro-Lab ",
    title2:"GB Custom",
    description:
      "Customized controlled-atmosphere systems designed and engineered to meet the unique requirements of complex research and industrial workflows.",
      imgUrl:
    gbCustom
  },

  productsDetails: {
    imgList: [
      gbCustom,
      gbCustom1,
      gbCustom2,
      gbCustom3,
      first,second,third
    ],

    productName: "Pro-Lab GB Custom Glove Box",

    description:
      "Pro-Lab GB Custom delivers fully configurable glovebox solutions engineered for demanding applications across advanced materials research, battery manufacturing, pharmaceutical synthesis, semiconductor preparation, and other specialized environments requiring precise atmosphere control.",

    keyFeatures: [
      "Fully tailored glovebox configuration per application specification",
      "Flexible integration with automation, robotics, and instrumentation",
      "High-performance atmosphere control (<1 ppm O₂ & H₂O optional)",
      "Modular chamber design for future expansion",
      "Custom port layouts, antechambers, and feedthrough options",
    ],

    download: {
      title: "Download Custom System Brochure",
      downloadLink: "",
    },

    reviewList: [],
    descriptionTitle:"Product Description",
    briefDescirption:
      "Pro-Lab GB Custom systems are engineered in collaboration with your technical team for precise specification matching. These bespoke solutions provide unmatched atmosphere control, ergonomic operation, and long-term serviceability for specialized industrial and laboratory applications.",
  },
};
